/* eslint-disable @next/next/no-img-element */
import React from 'react'

const socialLinks = [
  { href: "https://facebook.com", icon: "/images/facebook_icon.svg", label: "Facebook" },
  { href: "https://twitter.com", icon: "/images/twitter_icon.svg", label: "Twitter" },
  { href: "https://youtube.com", icon: "/images/youtube_icon.svg", label: "YouTube" },
  { href: "https://instagram.com", icon: "/images/insta_icon.svg", label: "Instagram" },
];

function SocialLinks() {
  return (
    <>
      <ul className="social_links">
        {socialLinks.map((item, index) => (
          <li key={index}>
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              <img src={item.icon} alt={item.label} />
            </a>
          </li>
        ))}
      </ul>
    </>
  )
}

export default SocialLinks